<template>
  <div class="event-popup-company">
    <EventPopupCompanyLogo :logo-url="company.square_logo" />
    <div class="event-popup-company__right">
      <div class="event-popup-company__business-category">{{ company.business_category_name }}</div>
      <div class="event-popup-company__name" v-text="company.name"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from '@vue/composition-api';
import { EventCompany } from 'oc2api/popup';
import EventPopupCompanyLogo from './EventPopupCompanyLogo.vue';
import noImageIcon from '../../../images/noimage.png';

export default defineComponent({
  name: 'EventPopupCompany',
  components: {
    EventPopupCompanyLogo,
  },
  props: {
    company: {
      type: Object as PropType<EventCompany>,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';
@import 'stylesheets/variables';

.event-popup-company {
  display: flex;
}

.event-popup-company__right {
  margin-left: 16px;
}

.event-popup-company__logo {
  flex: none;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  border: 1px solid $oc-border;
}

.event-popup-company__business-category {
  font-size: 10px;
  line-height: 150%;
  font-weight: 400;
  letter-spacing: 0.02em;
  color: $oc-gray80;
}

.event-popup-company__name {
  flex: auto;
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  color: $oc-black;
}
</style>
